import withStyles from "@material-ui/core/styles/withStyles";
import theme, { rawTheme } from "../../../../../styles/theme";
import { makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";

export const ActionButton = withStyles({
    root: {
        border: `1px solid ${theme.palette.borderColor}`,
        borderRadius: "5px",
        textTransform: "none",
        fontSize: "12px",
        background: `${rawTheme.palette.white}`,

        "&:hover": {
            background: `${rawTheme.palette.lightGrey}`,
            border: `1px solid ${theme.palette.grey}`,
        },
    },
})(Button);

export const ClearButton = withStyles({
    root: {
        border: "none",
        borderRadius: "5px",
        textTransform: "none",
        fontSize: "12px",
        background: `${rawTheme.palette.white} !important`,

        "&:hover": {
            background: `${rawTheme.palette.lightGrey} !important`,
            border: `1px solid ${theme.palette.grey}`,
        },
    },
})(Button);

const checkBoxStyles = (theme) => ({
    root: {
        "&$checked": {
            color: `${rawTheme.palette.darkMint}`,
        },
        height: "20px",
        width: "20px",
    },
    checked: {},
});
export const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);

export const useStyles = makeStyles({
    wrapper: {
        width: "100%",
        height: "85%",
        borderRadius: "5px",
        border: `1px solid ${theme.palette.borderColor}`,
        padding: "15px",
        background: `${theme.palette.white}`,
    },

    agWrapper: {
        width: "100%",
        height: "calc(100% - 60px)",

        paddingBottom: "15px",

        "--ag-active-color": `${rawTheme.palette.white}`,
        "--ag-input-border-color": `${rawTheme.palette.lightGrey}`,
        "--ag-checkbox-checked-color": "#00A39E",
        "--ag-selected-row-background-color": `${rawTheme.palette.lightGrey}`,
        "--ag-input-focus-border-color": `${rawTheme.palette.lightGrey}`,

        "& .ag-root": {
            fontSize: "11px",
            fontFamily: " 'Lato', sans-serif",
        },

        "& .ag-root-wrapper": {
            borderRadius: "0px",
            border: "none,",
        },

        "& .ag-header": {
            backgroundColor: `${rawTheme.palette.white}`,
        },
    },

    listRowItem: {
        padding: "8px 0",
        lineHeight: "normal",
    },

    gridRow: {
        borderBottom: `1px solid ${theme.palette.borderColor}`,

        "&:hover": {
            background: `${rawTheme.palette.lightGrey}`,
        },

        "& .ag-cell-wrapper": {
            height: "100%",

            "& .ag-checkbox-input": {
                marginTop: "0",
            },
        },
    },

    gridCell: {
        display: "flex",
        padding: "9px 0",
        alignItems: "center",
        justifyItems: "start",
        gap: "15px",
    },

    selectBox: {
        borderRadius: "5px",
        border: `1px solid ${theme.palette.borderColor}`,
        padding: "5px 10px",
        marginBottom: "10px",
        boxShadow: `1px 1px 10px 0px ${theme.palette.borderColor}`,
        display: "flex",
        alignItems: "center",

        "& .itemsSelected": {
            minWidth: "120px",
        },

        "& .buttonGroup": {
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",

            "& .actionButtons": {
                display: "flex",
                gap: "10px",
            },
        },

        "& .counter": {
            border: `1px solid ${theme.palette.borderColor}`,
            background: `${theme.palette.borderColor}`,
            marginRight: "10px",
            padding: "7px",
            borderRadius: "360px",
            width: "35px",
            textAlign: "center",
        },
    },

    filterBox: {
        marginBottom: "13px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",

        "& .filterGroup": {
            display: "flex",
            alignItems: "center",
            gap: "10px",
        },
    },

    active: {
        borderRadius: "5px",
        padding: "5px",
        background: `${rawTheme.palette.successAlertTextColor}`,
        width: "fit-content",
    },
    inactive: {
        borderRadius: "5px",
        padding: "5px",
        background: `${rawTheme.palette.grey}`,
        width: "fit-content",
    },
    filter: {
        border: `1px solid ${theme.palette.borderColor}`,
        borderRadius: "5px",
        textTransform: "none",
        fontSize: "12px",
        background: `${rawTheme.palette.white} !important`,

        "&:hover": {
            background: `${rawTheme.palette.lightGrey} !important`,
            border: `1px solid ${theme.palette.grey}`,
        },
    },
    filterMenu: {
        padding: "8px",
        borderRadius: "5px",
        boxShadow: `1px 1px 10px 0px ${theme.palette.borderColor}`,

        "& .filterMenuItem": {
            textTransform: "none",
            fontSize: "12px !important",
        },

        "& .filterMenuSearchBar": {
            border: `1px solid ${theme.palette.grey}`,
            borderRadius: "5px",
            margin: "2px 5px",
            display: "flex",
            alignItems: "center",

            "& .filterMenuTextField": {
                height: "32px !important",
                textTransform: "none !important",
                fontSize: "12px !important",
            },

            "& .filterMenuSearchIcon": {
                margin: "5px",
            },
        },

        "& .filterMenuDateRangeButton": {
            alignItems: "center",
            justifyContent: "flex-end",
        },
    },
});
